<div class="m-0 roomDetailHeader policyHeader" mat-dialog-title>
  <h5 class="modalTitle">{{ rGuestBookMessage.footer.depstandCanclatnPolicyHeader }}</h5>
  <i data-dismiss="modal" (click)="closeModal()" class="policy-material-icons cursor-pointer" class="fa fa-times" aria-hidden="true"></i>
</div>
<mat-dialog-content class="m-0 dialog-content">
  <div class="p-3 room-content">
    <div>
      <h5 class="dep-policy-title">{{ rGuestBookMessage.footer.depositPolicyTitle }}</h5>
      <div>
        <h5 [innerHtml]="data.depositPolicy || rGuestBookMessage.footer.depositNoDescription | safeHtml"></h5>
      </div>
      <div>
        <h5 class="depKey1 d-inline">{{ rGuestBookMessage.footer.depositKeyName1 }}</h5>
        <h5 class="depKey2 d-inline">
          {{
            (data.depositAmount || 0) * newRate
              | custCurrency
                : this.currencyCode || appInitializer.PropertyData.currencyCode
                : this.countryCode || appInitializer.PropertyData.countryCode
          }}
        </h5>
      </div>
    </div>
    <div
      *ngIf="
        data.cancellationPolicy ||
        data.cancellationDueDate != 'NA' ||
        (!(data.hideConfidentialRates && data.confidentialRate == 'Y') &&
          data.cancellationAmount &&
          data.cancellationAmount != 'NA' &&
          data.cancellationAmount != '0.00' &&
          data.cancellationAmount != '0')
      ">
      <h5 class="dep-policy-title">{{ rGuestBookMessage.footer.cancellationPolicyTitle }}</h5>
      <div>
        <h5 [innerHtml]="data.cancellationPolicy || rGuestBookMessage.footer.cancellationNoDescription | safeHtml"></h5>
      </div>
      <div *ngIf="data.cancellationDueDate != 'NA'" [ngStyle]="!isValidCancellationDueDate && { display: 'inline' }">
        <h5 class="depKey1 d-inline">{{ rGuestBookMessage.footer.cancellationKeyName1 }}</h5>
        <h5 *ngIf="isValidCancellationDueDate" class="depKey2">
          {{ data.cancellationDueDate | custDate: appInitializer.PropertyData.dateFunctionConfig }}
        </h5>
        <h5 *ngIf="!isValidCancellationDueDate" class="depKey2" [ngStyle]="!isValidCancellationDueDate && { display: 'inline' }">
          {{ data.cancellationDueDate }}
        </h5>
      </div>
      <div
        *ngIf="
          !(data.hideConfidentialRates && data.confidentialRate == 'Y') &&
          data.cancellationAmount &&
          data.cancellationAmount != 'NA' &&
          data.cancellationAmount != '0.00' &&
          data.cancellationAmount != '0'
        ">
        <h5 class="depKey1 d-inline">{{ rGuestBookMessage.footer.cancellationKeyName2 }}</h5>
        <h5 class="depKey2 d-inline">
          {{
            (data.cancellationAmount || 0) * newRate
              | custCurrency
                : this.currencyCode || appInitializer.PropertyData.currencyCode
                : this.countryCode || appInitializer.PropertyData.countryCode
          }}
        </h5>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="float-right mat-dialog-actions">
  <div class="float-right">
    <button mat-raised-button color="warn" (click)="closeModal()" class="policy-close-btn">
      {{ rGuestBookMessage.footer.depstandCanclatnPolicyBtn }}
    </button>
  </div>
</mat-dialog-actions>
